var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIndicacionInfoLab = function SvgIndicacionInfoLab(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 78.487 78.108",
    enableBackground: "new 0 0 78.487 78.108",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FCEDF6",
    cx: 39.095,
    cy: 38.902,
    r: 38.628
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB2491",
    d: "M18.691,34.188h-2.627v-1.439c0-1.406-1.145-2.55-2.554-2.55h-3.233c-1.404,0-2.552,1.143-2.552,2.55v1.439 H5.097c-1.409,0-2.554,1.147-2.554,2.556v9.476c0,1.404,1.145,2.549,2.554,2.549h13.593c1.409,0,2.553-1.145,2.553-2.549v-9.476 C21.243,35.336,20.099,34.188,18.691,34.188z M14.754,34.188h-5.72v-1.439c0-0.682,0.559-1.242,1.242-1.242h3.233 c0.688,0,1.245,0.561,1.245,1.242V34.188z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E76DB6",
    d: "M18.691,34.162h-2.627v-1.439c0-1.406-1.145-2.55-2.554-2.55h-1.439v1.307h1.439 c0.688,0,1.245,0.561,1.245,1.242v1.439h-2.683v14.581h6.62c1.409,0,2.553-1.145,2.553-2.549v-9.476 C21.244,35.31,20.099,34.162,18.691,34.162z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2CC9D6",
    d: "M46.754,55.12h-2.627v-1.439c0-1.406-1.145-2.55-2.554-2.55H38.34c-1.404,0-2.552,1.143-2.552,2.55v1.439 h-2.627c-1.409,0-2.554,1.147-2.554,2.556v9.476c0,1.404,1.145,2.549,2.554,2.549h13.593c1.409,0,2.553-1.145,2.553-2.549v-9.476 C49.307,56.268,48.163,55.12,46.754,55.12z M42.818,55.12h-5.72v-1.439c0-0.682,0.559-1.242,1.242-1.242h3.233 c0.688,0,1.245,0.561,1.245,1.242V55.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9159CB",
    d: "M68.379,22.292h-2.627v-1.439c0-1.406-1.145-2.55-2.554-2.55h-3.233c-1.404,0-2.552,1.143-2.552,2.55v1.439 h-2.627c-1.409,0-2.554,1.147-2.554,2.556v9.476c0,1.404,1.145,2.549,2.554,2.549h13.593c1.409,0,2.553-1.145,2.553-2.549v-9.476 C70.932,23.439,69.788,22.292,68.379,22.292z M64.443,22.292h-5.72v-1.439c0-0.682,0.559-1.242,1.242-1.242h3.233 c0.688,0,1.245,0.561,1.245,1.242V22.292z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#B66464",
    strokeMiterlimit: 10,
    d: "M12.89,26.187c0,0,0.337-0.463,0.94-1.164"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#B66464",
    strokeMiterlimit: 10,
    strokeDasharray: "3.0709,3.0709",
    d: "M15.952,22.807 c5.71-5.343,17.909-12.032,23.494,20.849"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#B66464",
    strokeMiterlimit: 10,
    d: "M39.695,45.181c0.077,0.486,0.152,0.981,0.226,1.484 c0.085-0.5,0.171-0.993,0.258-1.478"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#B66464",
    strokeMiterlimit: 10,
    strokeDasharray: "3.0122,3.0122",
    d: "M40.749,42.224 c4.816-23.532,12.971-27.432,17.326-27.702"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#B66464",
    strokeMiterlimit: 10,
    d: "M59.572,14.567c0.914,0.115,1.452,0.352,1.452,0.352"
  }))), /*#__PURE__*/React.createElement("circle", {
    fill: "#B66464",
    cx: 39.921,
    cy: 48.666,
    r: 2.001
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B66464",
    cx: 12.376,
    cy: 27.391,
    r: 2.001
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B66464",
    cx: 61.708,
    cy: 15.241,
    r: 2.001
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A867EE",
    d: "M68.341,22.251h-2.627v-1.439c0-1.406-1.145-2.55-2.554-2.55h-1.439v1.307h1.439 c0.688,0,1.245,0.561,1.245,1.242v1.439h-2.683v14.581h6.62c1.409,0,2.553-1.145,2.553-2.549v-9.476 C70.894,23.399,69.749,22.251,68.341,22.251z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8E6EB",
    d: "M46.617,55.071H43.99v-1.439c0-1.406-1.145-2.55-2.554-2.55h-1.439v1.307h1.439 c0.688,0,1.245,0.561,1.245,1.242v1.439h-2.683v14.581h6.62c1.409,0,2.553-1.145,2.553-2.549v-9.476 C49.17,56.219,48.026,55.071,46.617,55.071z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIndicacionInfoLab, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IndicaciónInfoLab.33563c1b.svg";
export { ForwardRef as ReactComponent };